import { useUser } from "@/app/context/UserContext";
import { getcurrentUser } from "@/app/helpers/functions";
import { iActionRequest } from "@/app/models/interfaceChatBotAction";
import { chatbotSaveAction } from "@/app/services/chatbotsaveaction";
import { forwardRef } from "react";

interface LinkChatProps extends React.HTMLAttributes<HTMLSpanElement> {
  actionCode: string;
  href: string;
  newTab?: boolean;
}

const LinkChat = forwardRef<HTMLSpanElement, LinkChatProps>(
  ({ actionCode, children, href, newTab = true, ...props }, ref) => {
    const { user, userProject,accessType } = useUser();

    const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
      props.onClick?.(e);
      if (!user?.email) return;

      const data = { href };

      const formObject = {
        target: "link",
        type: "a",
        data,
      };

      const request: iActionRequest = {
        company_code: userProject?.project?.company_code ?? "",
        project_id: userProject?.project?.id ?? "",
        //user_id: user.email,
        user_id: getcurrentUser(accessType, userProject, user),
        action_code: actionCode,
        action_detail: formObject,
      };

      chatbotSaveAction(request).catch((error) => {
        console.error("Error al guardar acción de link:", error);
      });

      // Abrir link
      if (newTab) {
        window.open(href, "_blank");
      } else {
        window.location.href = href;
      }
    };

    return (
      <span
        {...props}
        ref={ref}
        onClick={handleClick}
        className={` cursor-pointer ${props.className || ""}`}
      >
        {children}
      </span>
    );
  }
);

LinkChat.displayName = "LinkChat";
export default LinkChat;
